/**
 * Family-local layout shared by the ändring / uppsägning letters
 * (andring_hyresvillkor[_forhandlingsklausul], villkorsandring_54a,
 * uppsagning_{villkorsandring,avflyttning}_lokal). Slot, option, value and
 * signing helpers come from the common kit (`../common/index.js`).
 */
import { details, nodes, p, strong, t } from '@hyranai/regta-document-ir';
import { textVal } from '../common/index.js';
/** The legacy boxed InfoTable: "label — value" rows, each value read from a slot. */
export const boxedRows = (input, rows) => details(rows.map(([label, key]) => [label, [textVal(input, key)]]), { variant: 'boxed' });
/** The small uppercase kicker / bold title / italic subtitle opening of a meddelande. */
export function letterOpening(lines) {
    return nodes(lines.kicker ? p([strong(lines.kicker)], { variant: 'caption' }) : null, lines.title ? p([strong(lines.title)], { variant: 'lead' }) : null, lines.subtitle ? p([{ type: 'emphasis', content: [t(lines.subtitle)] }], { variant: 'intro' }) : null, lines.note ? p([strong(lines.note)], { variant: 'caption' }) : null);
}
//# sourceMappingURL=kit.js.map